import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../../assets/css/Customermodalbox.css';
import SelectCustomer from './SelectCustomer';
import { useNavigate } from "react-router-dom";

function CustomerModalbox() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();

  return (
    <>
     <Button className="btn  btnyellow mt-1" onClick={handleShow} style={{ fontSize: "13px", borderRadius:"0"}}>  PROCEED TO CHECKOUT </Button> 

     <div className='bodymodalbox'> 
      <Modal show={show} onHide={handleClose}>
        <Modal.Body> 
         <SelectCustomer/>
           <p className='mb-3 text-sm'>  do you want to continue this customer or change ? </p>
          <div className=' d-flex justify-content-end'> 
          <Button className='btn btn-light btn-outline-dark btn-small' onClick={handleClose}>
              Change
          </Button>
          <Button className='savebtn btn-small'  onClick={() => navigate("/ordersucessfull")} style={{ backgroundColor: "rgb(21 21 20)", color:"#FFF" }}>
               Proceed
          </Button>
          </div>
        </Modal.Body>
      </Modal>
      </div>
    </>
  );
}
export default CustomerModalbox;